import { FilterOption, IncomingConsultation } from '../../../types';
import { RecoilState, RecoilValueReadOnly } from 'recoil';
import {
  incomingConsultationsTrafficMonitorFiltersState,
  incomingConsultationsTrafficMonitorPageNumberState,
  incomingConsultationsTrafficMonitorPageSizeState,
  incomingConsultationsTrafficMonitorSortByState,
  incomingConsultationsTrafficMonitorOrderByColumnState,
  incomingConsultationsTrafficMonitorOrderByDescendingState,
  incomingConsultationsTrafficMonitorRequestState,
} from '../../../store';
import { GetIncomingConsultationsRequest } from '../../../api';
import { SortingRule } from 'react-table';

export type UseIncomingConsultationsTrafficMonitorStateReturn = {
  filterState: RecoilState<FilterOption[]>;
  pageNumberState: RecoilState<number>;
  pageSizeState: RecoilState<number>;
  sortByState: RecoilValueReadOnly<SortingRule<IncomingConsultation>[]>;
  orderByColumnState: RecoilState<string | undefined>;
  orderByDescendingState: RecoilState<boolean>;
  requestState: RecoilValueReadOnly<GetIncomingConsultationsRequest>;
};

export const UseIncomingConsultationsTrafficMonitorState =
  (): UseIncomingConsultationsTrafficMonitorStateReturn => {
    return {
      filterState: incomingConsultationsTrafficMonitorFiltersState,
      pageNumberState: incomingConsultationsTrafficMonitorPageNumberState,
      pageSizeState: incomingConsultationsTrafficMonitorPageSizeState,
      sortByState: incomingConsultationsTrafficMonitorSortByState,
      orderByColumnState: incomingConsultationsTrafficMonitorOrderByColumnState,
      orderByDescendingState: incomingConsultationsTrafficMonitorOrderByDescendingState,
      requestState: incomingConsultationsTrafficMonitorRequestState,
    };
  };
